import { useState } from "react";
import styled from "styled-components";
import { withAppHOC } from "../../hoc";
import {
  StyledContentContainer,
  StyledMainAreaContainer,
} from "../../components/styled";
import PageHeader from "../../components/PageHeader/PageHeader";
import {
  Form,
  Fieldset,
  Label,
  TextInput,
  MessageBox,
  Button,
} from "../../components/FormElements";
import API from "../../api";
import { RESPONSE_STATUSES } from "../../constants";
import { formatCurrency,formatCurrency4Decimal, getAuthData, getReturnUrl } from "../../utils";

const StyledRedeemableBalance = styled.p`
  font-size: 14px;
  color: green;
  margin: 0px;
  padding: 0px;
`;

const SwitchFunds = () => {
  const {
    userProfile: {
      gstSellerWallet,
      redeemableGstBalance,
      blockedAmount,
    },
  } = getAuthData();

  const [state, setState] = useState({
    isLoading: false,
    responseStatus: "",
    responseMessage: "",
    fromWallet: "gstSellerWallet",
    toWallet: "gstBuyerWallet",
    amount: "",
  });

  const onSubmit = async (e) => {
    e.preventDefault();
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
      responseStatus: "",
      responseMessage: "",
    }));
    try {
      const response = await API.post("/payments/switch-funds", {
        fromWallet: state.fromWallet,
        toWallet: state.toWallet,
        amount: state.amount,
      });
      const { status, message } = response.data;
      if (status === RESPONSE_STATUSES.SUCCESS) {
        setState((prevState) => ({
          ...prevState,
          responseStatus: RESPONSE_STATUSES.SUCCESS,
          responseMessage: message,
          fromWallet: "gstSellerWallet",
          toWallet: "gstBuyerWallet",
          amount: "",
        }));
        setTimeout(() => {
          setState((prevState) => ({
            ...prevState,
            responseStatus: "",
            responseMessage: "",
          }));
          window.location.href = getReturnUrl("create");
        }, 3000);
      } else {
        setState((prevState) => ({
          ...prevState,
          responseStatus: RESPONSE_STATUSES.FAILED,
          responseMessage: message,
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        responseStatus: RESPONSE_STATUSES.FAILED,
        responseMessage: error.message,
      }));
    } finally {
      setState((prevState) => ({ ...prevState, isLoading: false }));
    }
  };

  const renderPageHeading = () => (
    <PageHeader title="Switch Funds" showBackButton={true} />
  );

  const finalAllowedBalance = parseFloat(redeemableGstBalance - blockedAmount);

  return (
    <>
      {renderPageHeading()}
      <StyledContentContainer>
        <StyledMainAreaContainer>
          <Form
            action="#"
            method="POST"
            onSubmit={onSubmit}
            style={{ maxWidth: "500px" }}
          >
            <Fieldset>
              <Label required>Amount</Label>
              <TextInput
                value={state.amount}
                isNumeric={true}
                onChange={(value) =>
                  setState((prevState) => ({
                    ...prevState,
                    amount: value,
                  }))
                }
                placeholder="Amount"
                disabled={state.isLoading}
              />
            </Fieldset>
            <Fieldset>
              <StyledRedeemableBalance>
                Wallet Balance : {formatCurrency4Decimal(gstSellerWallet)}
              </StyledRedeemableBalance>
            </Fieldset>
            <Fieldset>
              <Fieldset>
                <StyledRedeemableBalance>
                  Available Balance to Redeem:{" "}
                  {formatCurrency4Decimal(finalAllowedBalance < 0 ? 0 : finalAllowedBalance)}
                </StyledRedeemableBalance>
              </Fieldset>
            </Fieldset>
            <Fieldset>
              <StyledRedeemableBalance>
                Blocked Amount : {formatCurrency(blockedAmount)}
              </StyledRedeemableBalance>
            </Fieldset>
            {state.responseStatus && state.responseMessage && (
              <Fieldset>
                <MessageBox
                  status={state.responseStatus}
                  message={state.responseMessage}
                />
              </Fieldset>
            )}
            <Fieldset>
              <Button disabled={state.isLoading}>Submit</Button>
            </Fieldset>
          </Form>
        </StyledMainAreaContainer>
      </StyledContentContainer>
    </>
  );
};

export default withAppHOC(SwitchFunds);
